import Vue from 'vue'
import VueI18n from 'vue-i18n'

// 安装Vue-i18n插件
Vue.use(VueI18n)

// 导入语言包
const messages = {
    'en': require('./locales/en.json'),
    'zh-CN': require('./locales/zh-CN.json'),
    'zh-TW': require('./locales/zh-TW.json'),
    'ar': require('./locales/ar.json')
}

// 创建Vue-i18n实例
const i18n = new VueI18n({
    // 设置默认语言
    locale: localStorage.getItem('hcc-language') || 'zh-CN',
    // 备用语言（当当前语言缺少翻译时使用）
    fallbackLocale: 'en',
    // 导入的语言包
    messages,
    // 格式化选项（可选）
    numberFormats: {
        'en': {
            currency: {
                style: 'currency',
                currency: 'USD'
            }
        },
        'zh-CN': {
            currency: {
                style: 'currency',
                currency: 'CNY'
            }
        }
    },
    // 日期时间格式化选项（可选）
    dateTimeFormats: {
        'en': {
            short: { year: 'numeric', month: 'short', day: 'numeric' }
        },
        'zh-CN': {
            short: { year: 'numeric', month: 'long', day: 'numeric' }
        },
        'zh-TW': {
            short: { year: 'numeric', month: 'long', day: 'numeric' }
        },
        'ar': {
            short: { year: 'numeric', month: 'long', day: 'numeric' }
        }
    }
})

export default i18n
